import { Navigate, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { useAuth } from "../context/AuthContext";

/**
 * Premium gate — auth + agreement + active premium subscription required.
 * - Anonymous → opens AuthModal in signup mode and redirects to /
 * - Auth'd but no agreement → opens AgreementModal and redirects to /
 * - Auth'd + signed but not premium → opens PaywallModal and redirects to /
 */
export default function PremiumRoute({ children }) {
  const {
    loading, user, hasSignedAgreement, isPremium,
    setAuthModalOpen, setAuthModalMode,
    setAgreementModalOpen, setPaywallModalOpen,
    setPostAuthRedirect,
  } = useAuth();
  const location = useLocation();

  useEffect(() => {
    if (loading) return;
    const redirect = location.pathname + location.search;
    if (!user) {
      setPostAuthRedirect(redirect);
      setAuthModalMode("signup");
      setAuthModalOpen(true);
    } else if (!hasSignedAgreement) {
      setPostAuthRedirect(redirect);
      setAgreementModalOpen(true);
    } else if (!isPremium) {
      setPostAuthRedirect(redirect);
      setPaywallModalOpen(true);
    }
  }, [loading, user, hasSignedAgreement, isPremium, location,
      setAuthModalOpen, setAuthModalMode, setAgreementModalOpen,
      setPaywallModalOpen, setPostAuthRedirect]);

  if (loading) {
    return <div className="min-h-[60vh] flex items-center justify-center text-gray-500" data-testid="premium-route-loading">Loading…</div>;
  }
  if (!user || !hasSignedAgreement || !isPremium) {
    return <Navigate to="/" replace />;
  }
  return children;
}
